import React, { useRef, useEffect, useState } from "react"
import Layout from "./"
import Row from "./row"
import styled from "@emotion/styled"
import BackwardButton from "../common/backwardButton"
import ToTopIcon from "../../assets/totop.svg"

// // Small devices (landscape phones, 576px and up)
// @media (min-width: 576px) { ... }

// // Medium devices (tablets, 768px and up)
// @media (min-width: 768px) { ... }

// // Large devices (desktops, 992px and up)
// @media (min-width: 992px) { ... }

// // Extra large devices (large desktops, 1200px and up)
// @media (min-width: 1200px) { ... }

const PageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 31px;
  @media (min-width: 768px) {
  }
  ${props => props.theme.tablet} {
    flex-direction: column;
    margin-top: 1rem;
    ul {
      padding-inline-start: 0em;
    }
  }
`

const ConceptWrapper = styled.div`
  margin-top: 31px;
`

const ConceptNameWrapper = styled.div`
  font-size: 1.8rem;
  ${props => props.theme.tablet} {
    font-size: 1.3rem;
    font-weight: 600;
  }
`

const Heading = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 20px;
  ${props => props.theme.tablet} {
    font-size: 1.2rem;
  }
`

const LeftColumnWrapper = styled.div`
  flex-basis: 27%;
  padding-right: 1rem;
  ${props => props.theme.mobile} {
    padding-bottom: 2rem;
    padding-right: 0rem;
  }
`

const LeftColumn = styled.div`
  position: ${props => (props.sticky ? "sticky" : "static")};
  top: 1.5rem;
  ${props => props.theme.mobile} {
    position: static;
  }
  a {
    color: black;
  }

  ul {
    list-style: none;
    margin: 0;
    padding-inline-start: 0;
    li {
      margin: 20px 0;
      cursor: pointer;
      &:hover {
        a {
          border-bottom: 1px solid black;
        }
      }
      &:before { 
        content:"\u003E"; 
        font-size: 1.3rem;
        padding-right: 0.7rem;
        }
      }
    }

  }
`

const ContentWrapper = styled.div`
  flex-basis: 73%;
  line-height: 1.7;
  min-height: 60vh;
  p {
    padding-bottom: 1rem;
  }
  h1 {
    padding-bottom: 1rem;
  }
  ${props => props.theme.tablet} {
    h1 {
      font-size: 1.1rem;
    }
  }
`

const ScrollToTopButton = styled.button`
  position: fixed;
  display: none;
  z-index: 999;
  right: 1rem;
  bottom: 1rem;
  border-radius: 50%;
  border: none;
  background: gray;
  padding: 0.4rem 0.5rem;
  ${props => props.theme.tablet} {
    display: block;
    svg {
      fill: white;
      width: 40px;
      height: 40px;
    }
  }
`

const Sidebar = ({
  children,
  heading,
  leftColumn,
  sticky,
  concept,
  conceptName,
}) => {
  const leftColumnWrapperRef = useRef(null)
  const [showTopButton, setShowTopButton] = useState(false)

  const handleTopButtonShow = () => {
    if (window.pageYOffset > 400) {
      setShowTopButton(true)
    } else {
      setShowTopButton(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleTopButtonShow)
    return () => {
      window.removeEventListener("scroll", handleTopButtonShow)
    }
  })

  const scrollToNav = () => {
    const rootElement = document.documentElement
    rootElement.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <Layout light>
      <Row margin="1rem auto">
        {concept && (
          <ConceptWrapper>
            <BackwardButton />
            <ConceptNameWrapper>{conceptName}</ConceptNameWrapper>
          </ConceptWrapper>
        )}
        <PageWrapper>
          <LeftColumnWrapper ref={leftColumnWrapperRef}>
            <LeftColumn sticky={sticky}>
              {!concept && <BackwardButton />}
              {!concept && <Heading>{heading}</Heading>}
              {leftColumn && leftColumn}
            </LeftColumn>
          </LeftColumnWrapper>
          <ContentWrapper>{children}</ContentWrapper>
        </PageWrapper>

        {showTopButton && (
          <ScrollToTopButton onClick={() => scrollToNav()}>
            <ToTopIcon />
          </ScrollToTopButton>
        )}
      </Row>
    </Layout>
  )
}

export default Sidebar
